import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_EN_CURS,
         AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_FINALITZADA } from '../../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const tots = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_EN_CURS:
            return true;

        case AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default tots;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/comentaris/peticioObtenirEnCurs.js